import { render, staticRenderFns } from "./CriarElementoItem.vue?vue&type=template&id=155c63f3&scoped=true"
import script from "./CriarElementoItem.vue?vue&type=script&lang=js"
export * from "./CriarElementoItem.vue?vue&type=script&lang=js"
import style0 from "./CriarElementoItem.vue?vue&type=style&index=0&id=155c63f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c63f3",
  null
  
)

export default component.exports